import safeURLParse from '@/utils/safeURLParse'

export function withWidth(url: string, width: number) {
    const parsed = safeURLParse(url)
    if (!parsed) {
        return url
    }
    parsed.searchParams.set('width', String(width))
    return parsed.toString()
}

// windows from 640px take 1200; narrower ones ask for 149px, under 448 even at 3x, so phones take 448
export function previewImage(url: string) {
    return {
        src: withWidth(url, 1200),
        srcset: `${withWidth(url, 448)} 448w, ${withWidth(url, 1200)} 1200w`,
        sizes: '(min-width: 640px) 1200px, 149px',
    }
}
